<template>
    <div v-if="!isLoading" class="app">
        <div class="app">
            <router-view></router-view>
        </div>
        <div v-show="alertMessages.length" class="alerts-wrapper">
            <alert
                v-for="(item, index) in alertMessages"
                :key="index"
                :type="item.type"
                :header-text="item.headerText"
                :message="item.message"
                :button-text="item.buttonText"
                @onClose="removeAlertMessage({index, autoRemove: false}); item.closeHandler ? item.closeHandler() : null"
                @buttonClick="item.buttonHandler ? item.buttonHandler() : null"
                @outsideClick="item.outsideClickHandler ? item.outsideClickHandler() : null"
            ></alert>
        </div>
    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import Alert from "./components/defaults/Alert.vue";
import Vue from "vue";
import {applyCaptcha} from "./helpers/CaptchaHelper";
import {fetchIndexPageConfig} from "./api/commonApi";
import {checkStatus} from "./api/mainApi";

export default {
    name: "App",
    components: {Alert},
    computed: {
        ...mapGetters(['alertMessages', 'isLoading'])
    },
    watch: {
        alertMessages(messages) {
            this.clearAlerts(messages.length - 1)
        }
    },
    created() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        window.addEventListener('resize', () => {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`)
        });

        fetchIndexPageConfig()
            .then(response => {
                const captchaKey = response.data.captcha_key;

                if (captchaKey) {
                    applyCaptcha(captchaKey)
                }

                if (response.data.env_name.indexOf('prod') == -1) {
                    Vue.config.devtools = true
                } else {
                    Vue.config.devtools = false
                }
            })
          .catch(() => {})

        checkStatus()
            .then(() => {
                this.changeIsLogged(true)
                this.$router.currentRoute.name === 'login' ? this.$router.push('/') : ''
            })
            .catch(() => {})
            .finally(() => {
                this.changeIsLoading(false)
                const element = document.getElementById('app___loading')
                element.style.display = 'none'
            })
    },
    methods: {
        ...mapActions([
            'removeAlertMessage',
            'changeIsLoading',
            'changeIsLogged'
        ]),
        ...mapActions("callParkings", ["removeSlot", "addSlot"]),

        clearAlerts (index) {
            if (this.alertMessages.length) {
                setTimeout(() => {
                    this.removeAlertMessage({index, autoRemove: true})
                }, 10000)
            }
        }
    }
}

</script>
